<div
  [ngClass]="{
    'form-header-container': !error && !warning,
    'form-header-container-warning': warning,
    'form-header-container-error': error,
  }"
>
  <div class="d-flex justify-content-between align-items-center total-step-width header-content">
    <div
      class="wizard-text-header d-flex flex-column justify-content-between"
      [ngClass]="{ 'flex-row': warning || error, 'align-item-center': warning || error }"
    >
      <!--Normal Case-->
      @if (!warning && !error) {
        <div class="step-title">
          {{ stepTitle && (stepTitle | translate) }}
        </div>
      }

      <!--Warning || Error Case-->
      @if (warning || error) {
        <div class="d-flex">
          @if (warning) {
            <mat-icon svgIcon="info-circle-filled" />
          }
          @if (error) {
            <mat-icon svgIcon="alert-triangle-fill" />
          }
          <div
            class="d-flex step-title align-items-center warning-or-error add-marge-adapter"
            ngbTooltip="{{ stepSubTitle && (stepSubTitle | translate) }}"
            tooltipClass="tooltip-alert-error"
            placement="bottom"
          >
            {{ stepTitle && (stepTitle | translate) }}
          </div>
        </div>
      }

      @if (!warning && !error) {
        <div
          class="step-sub-title d-flex"
          [ngClass]="{
            'add-marge-adapter': error || warning,
            empty: currentSelectionValue === 0 && !step?.isComplete && step?.stepIndex !== 4,
            'not-empty': currentSelectionValue > 0 || step?.isComplete,
          }"
        >
          @if (currentSelectionValue === 0 && !step?.isComplete && step?.stepIndex !== 4) {
            <span> {{ stepSubTitleEmptySelection && (stepSubTitleEmptySelection | translate) }}</span>
          }
          @if (currentSelectionValue > 0 || step?.isComplete) {
            <span> {{ stepSubTitle && (stepSubTitle | translate) }}</span>
          }
          @if (selectionComplexityLimitationValue && maxSelectionValue > selectionComplexityLimitationValue) {
            <app-progress-bar
              [nameValue]="valueName"
              [currentValue]="currentSelectionValue"
              [maxValue]="selectionComplexityLimitationValue"
              [progressBarWidth]="progressBarWidth"
            >
            </app-progress-bar>
          } @else {
            <div class="invisible">I'm invisible</div>
          }
        </div>
      }
    </div>

    <div class="wizard-buttons-header d-flex justify-content-between">
      <div class="d-flex">
        @if (!isFirstStep()) {
          <button (click)="onPrevStep()" class="btn align-self-center btn-prev d-flex">
            <div class="icon-btn icon-btn--arrow-left align-self-center"></div>
          </button>
        }

        <div
          class="add-marge-adapter-next align-self-center"
          [ngbTooltip]="error ? tipAlert : ''"
          tooltipClass="{{ alertId ? 'tooltip-alert-error' : 'tooltip-alert-warning' }}"
          placement="bottom"
        >
          <!--On masque le bouton suivant pour les deux dernières étapes-->
          @if (!isOneOfTwoLastSteps()) {
            <button
              data-cy="digest-next-button"
              (click)="onNextStep()"
              [disabled]="awaitingSubmission || error || !(currentStep | async)?.isComplete"
              class="primary-explain-button mgl-16px align-self-center d-flex"
            >
              <ng-container>
                <div class="align-self-center">{{ 'button.next' | translate }}</div>
                <div class="align-self-center icon-wizard icon-wizard--arrow-right"></div>
              </ng-container>
            </button>
          }
        </div>
      </div>

      <ng-template #tipAlert>
        <div class="text-left">
          <div>{{ 'button.alert-anomalies' | translate }}</div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
